import { getSensorHistory } from '@Actions/sensors';
import { getValue } from '@Selectors';
import { subYears } from 'date-fns';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

export default function useGetSensorHistory() {
	const { reload } = useSelector(getValue).editSensorData;
	const { sensorId } = useParams<{ sensorId: string }>();

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(
			getSensorHistory({
				sensorId,
				startDate: subYears(Date.now(), 1),
				endDate: new Date(),
				order: 'DESC',
				offset: 0,
				limit: 100,
			}),
		);
	}, []);
	useEffect(() => {
		if (reload) {
			dispatch(
				getSensorHistory({
					sensorId,
					startDate: subYears(Date.now(), 1),
					endDate: new Date(),
					order: 'DESC',
					offset: 0,
					limit: 100,
				}),
			);
		}
	}, [reload]);
}
